import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
const app = createApp(App)


// 引入elementui
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
app.use(ElementPlus)

// 引入echarts
import * as echarts from "echarts";
app.config.globalProperties.$echarts = echarts;

// 引入 flexible 用于设置 rem 基准值
import 'lib-flexible/flexible.js'

// 接口工具
import api from './api/api';
import api_tieling from './api/api-tieling';
app.config.globalProperties.$api = api;
app.config.globalProperties.$api_tieling = api_tieling;


app.use(store).use(router).mount('#app')
